import { PutLastCheckedResponseAllOfResult } from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { ILastCheckedResponse } from '../domains/entities/lastChecked';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';
import { DateService } from '@/coreDomainsModule/services/dateService';

/**
 * APIレスポンスの型をUI用に変換する
 */
export class PutLastCheckedAdapter {
  /**
   * フロント側の型に変換を行う
   * @param result - APIから返ってきたPutのResult
   */
  public static adapt = (result: PutLastCheckedResponseAllOfResult): ILastCheckedResponse => {
    return {
      aggregateBusinessId: result.aggregateBusinessId,
      lastCheckedUser: UserAccountFactory.create({ email: result.lastCheckedUser.id, name: result.lastCheckedUser.name }),
      lastCheckedAt: DateService.convertMSUnixTimeToDate(result.lastCheckedAt),
    };
  };
}
